import React, { useState } from 'react';
import SprichwortFirstHalf from './components/SprichwortFirstHalf';
import SprichwortSecondHalf from './components/SprichwortSecondHalf';
import { getRandomGroup, getRandomElement } from './data/sprichwoerterData';
import './App.css';

function App() {
  const [sprichwort, setSprichwort] = useState(() => {
    const group = getRandomGroup();
    return {
      firstHalf: getRandomElement(group.firstHalves),
      secondHalf: getRandomElement(group.secondHalves)
    };
  });

  const generateNewSprichwort = () => {
    const group = getRandomGroup();
    setSprichwort({
      firstHalf: getRandomElement(group.firstHalves),
      secondHalf: getRandomElement(group.secondHalves)
    });
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>🌟 Martha's Sprichwort Generator 🌟</h1>
        <p className="subtitle">Weisheiten mit Martha</p>
      </header>

      <main className="App-main">
        <div className="sprichwort-container">
          <div className="sprichwort-display">
            <SprichwortFirstHalf text={sprichwort.firstHalf} />
            <SprichwortSecondHalf text={sprichwort.secondHalf} />
          </div>

          <div className="complete-sprichwort">
            <p>"{sprichwort.firstHalf} {sprichwort.secondHalf}"</p>
          </div>
        </div>

        <button className="generate-button" onClick={generateNewSprichwort}>
          Neues Sprichwort generieren
        </button>

        <div className="info-section">
          <p>
            Jedes Mal wenn du den Button drückst, wird ein neues zufälliges Sprichwort generiert!
          </p>
          <p className="martha-note">
            ✨ Alle Sprichwörter wurden speziell für Martha angepasst ✨
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;

